<template>
  <div class="accessmenetDetail_div">
    <a-row>
      <a-col :span="8">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.projectEndtime')}}</div>
          <div class="value">{{detail.projectEndtime | dayjs('YYYY-MM')}}</div>
        </div>
      </a-col>
      <a-col :span="10">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.projectPossible')}}</div>
          <div class="value_1">{{detail.projectPossible | NumberFormat}}%</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.brokerage.totalBrokerage')}}</div>
          <div class="value_1">
            {{detail.totalBrokerage | NumberFormat}}
          </div>
        </div>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="8">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.priority')}}</div>
          <div class="value">{{detail.priority != '~' ?priorityOptions.find(e=>{ return e.wordKey == detail.priority}).wordValue:'~'}}</div>
        </div>
      </a-col>
      <a-col :span="10">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.competitionSituation')}}</div>
          <div class="value">{{this.detail.colleagueDOS != null ? detail.colleagueDOS.map(e=>{return e.companySortNameCn}).join(",") : '~'}}</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.mansions')}}</div>
          <div class="value" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
            <a-tooltip :title="detail.mansionNames">
              <span>{{detail.mansionNames}}</span>
            </a-tooltip>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row  class="deal_cascader">
      <a-col :span="24">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.targetArea')}}</div>
          <div class="value">
            <template v-if="detail.targetArea!='~' && detail.targetArea != '[]' ">
              <pt-multi-cascader
                :editMode="false"
                disabled
                :show-all-levels="false"
                :value="JSON.parse(detail.targetArea)"
                :styleObj="{width: '100%'}"
                size="small"
                :options="allCityDatas"
                :props="{multiple: true}"
                :clearable="false"></pt-multi-cascader>
            </template>
            <template v-else>
              ~
            </template>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findCascadingData } from '@/api/sys/datadict'
import customerApi from '@/api/mine/customer'

export default {
  name: 'assessmentDetail',
  props:{
    detail:{

    }
  },
  data(){
    return {
      allCityDatas:[],
      cityDatas:[],
      priorityOptions: [],
    }
  },
  mounted() {
    this.initCityData();
    this.initCustomerRelationShipOptions()
  },
  methods:{
    initCustomerRelationShipOptions(){
      customerApi.getCustomerRelationShipOptions().then(res=>{
        if(res.code == 1){
          this.priorityOptions = res.data
          this.priorityOptions.sort((a,b)=>{
            return a.listIndex - b.listIndex
          })
        }
      })
    },
    buildNewTree(tree,equalsValue){
      let stack = [tree]
      if(tree.value != equalsValue){
        for(let i = 0; i < tree.children.length; i++){
          if(tree.children[i].value == equalsValue){
            return stack
          }
        }
      }else{
        return stack
      }
    },
    initCityData(){
      let this_ = this
      findCascadingData("system.mansion_set.address",4).then(res=>{
        this_.allCityDatas = res.data
        let data
        for(let i = 0; i < res.data.length; i++){
          //只显示员工公司所在地
          data = this_.buildNewTree(res.data[i],this_.$store.getters.userInfo.companyDO.city.toLowerCase())
          if(data){
            break
          }
        }
        this_.cityDatas = data
      })
    },
  }
}
</script>

<style scoped lang="less">
.accessmenetDetail_div{
  background: #fafbfc;
  padding: 20px 24px;
  margin-top: 5px;
  .item{
    margin-bottom: 20px;
  }
  .title{
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }
  .value{
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;

  }
  .value_1{
    font-size: 12px;
    color: #FABE00;
    letter-spacing: 0;
  }
}
.deal_cascader{
  /deep/ .el-input__inner{
    padding-left:4px !important;
  }
  /deep/ .el-tag{
    margin-left: 0px !important;
    margin-right: 6px !important;
  }
}
</style>